import { useTranslation } from 'react-i18next'

import { linkifyText } from '../../../../../utils/text'
import { ClampingText } from '../../../../ClampingText'
import {
  isRequestWizardCardImageType,
  isRequestWizardCardLinkType,
  isRequestWizardCardTextType,
  isRequestWizardCardVariableType,
} from '../../RequestWizardForm.utils'

import { TEXT_CLAMPING_LINES_COUNT } from './Card.constants'
import { Divider } from './Divider'
import { Image } from './Image'
import { Link } from './Link'
import { Variable } from './Variable'

import * as styles from './Card.module.css'

function Card({ card, filesOptions, hasDivider }) {
  const { t } = useTranslation()

  const linkifiedText = isRequestWizardCardTextType(card.type)
    ? linkifyText({
        text: card.text,
        tooltip: t('Common.LinkTooltipOpenInNewTabKey'),
      })
    : undefined

  return (
    <>
      {isRequestWizardCardTextType(card.type) ? (
        <>
          <ClampingText
            clampingLinesCount={TEXT_CLAMPING_LINES_COUNT}
            fullText={linkifiedText}
            textClassName={styles.text}
          />
          {hasDivider ? <Divider /> : null}
        </>
      ) : null}
      {isRequestWizardCardVariableType(card.type) ? (
        <Variable card={card} filesOptions={filesOptions} />
      ) : null}
      {isRequestWizardCardImageType(card.type) ? (
        <>
          <Image
            description={card.description}
            file={card.file}
            title={card.title}
          />
          {hasDivider ? <Divider /> : null}
        </>
      ) : null}
      {isRequestWizardCardLinkType(card.type) ? (
        <Link links={card.links} />
      ) : null}
    </>
  )
}

export default Card
